import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.auth.PhoneField', {
    placeholderPhone: 'Phone',
    phoneTooltip: 'We need your phone number to enable security measures and associated communications.',
});
